import { render, staticRenderFns } from "./MultiDocumentPreviewModal.vue?vue&type=template&id=3f1244a6"
import script from "./MultiDocumentPreviewModal.vue?vue&type=script&lang=js"
export * from "./MultiDocumentPreviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports